import React from "react";
import { Box } from "@mui/material";
import {
  geometrieMontee,
  piedsALaMarche,
  placeDuBut,
  refugePlacement,
  trajectoireRocher,
  pointDeChute,
} from "../../../../frontend/src/utils/avalanchePlacement";
import { coursePoursuitePlacement } from "../../../../frontend/src/utils/coursePoursuitePlacement";
import { imageUrl } from "../../utils/scenarioVariants";
const W = 1408,
  H = 752;
export default function MotionScenarioPreview({
  config,
  scenarioId,
  progress,
  journey,
  slot,
}) {
  const rect = (r) => ({
    position: "absolute",
    left: `${(r.left / W) * 100}%`,
    top: `${(r.top / H) * 100}%`,
    width: `${(r.width / W) * 100}%`,
    height: `${(r.height / H) * 100}%`,
  });
  const marker = (label, r) => (
    <Box
      key={label}
      sx={{
        ...rect(r),
        border: "1px dashed #1976d2",
        bgcolor: "rgba(255,255,255,.65)",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 12,
        color: "#123",
      }}
    >
      {label}
    </Box>
  );
  if (scenarioId === "course_poursuite") {
    const g = coursePoursuitePlacement(config.layout, W, H);
    return (
      <Box sx={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
        {["player", "rival"].map((name) => {
          const a = g[name];
          return marker(name === "player" ? "Joueur" : "Rival", {
            left: a.startX + a.dx * progress,
            top: a.feetY + a.dy * progress - a.size,
            width: a.size,
            height: a.size,
          });
        })}
      </Box>
    );
  }
  const scene = config.layout.find((b) => b.name === "scene");
  const sw = (W * scene.wPct) / 100,
    sh = (H * scene.hPct) / 100;
  const g = geometrieMontee(sw, sh, config),
    pieds = piedsALaMarche(journey, 1, g, "montee"),
    but = placeDuBut(g, "montee");
  const bank = config.obstacleIllustrations?.[Number(slot.split(".")[1]) || 0];
  const kind =
    bank?.kind ||
    (slot.startsWith("images.projectiles.")
      ? slot.split(".")[2]
      : config.projectiles[0]);
  const image = bank ? bank.image : config.images?.projectiles?.[kind];
  const t = trajectoireRocher(
      0,
      { rochers: 1, grosBloc: true },
      pieds,
      g,
      bank?.heightPct,
      image?.ratio,
    ),
    point = pointDeChute(t, progress);
  const global = (r) => ({
    ...r,
    left: r.left + (W * scene.xPct) / 100,
    top: r.top + (H * scene.yPct) / 100,
  });
  const refuge = config.images?.refuge;
  const br = refuge
    ? refugePlacement(refuge, but, piedsALaMarche(1, 1, g, "montee"))
    : but;
  return (
    <Box sx={{ position: "absolute", inset: 0, pointerEvents: "none" }}>
      {marker(
        "Compagnon",
        global({
          left: pieds.x - g.compagnonTaille / 2,
          top: pieds.y - g.compagnonTaille,
          width: g.compagnonTaille,
          height: g.compagnonTaille,
        }),
      )}
      {refuge ? (
        <Box
          component="img"
          src={imageUrl(refuge.source)}
          alt="Refuge"
          sx={{ ...rect(global(br)), objectFit: "contain" }}
        />
      ) : (
        marker("Refuge", global(but))
      )}
      {image ? (
        <Box
          component="img"
          src={imageUrl(image.source)}
          alt="Projectile"
          sx={{
            ...rect(
              global({
                left: point.x,
                top: point.y,
                width: t.width,
                height: t.height,
              }),
            ),
            objectFit: "contain",
          }}
        />
      ) : (
        marker(
          "Projectile",
          global({
            left: point.x,
            top: point.y,
            width: t.width,
            height: t.height,
          }),
        )
      )}
    </Box>
  );
}
